// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".twitter-integration{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;font-size:14px}.twitter-integration .tw-picture{margin-right:10px}\n", ""]);
// Exports
module.exports = exports;
